'use strict';

/**
 * This is for raw data only. Leave bytesPerMilliGoodput and other derived attributes out of this.
 */
module.exports = {
    PASS_BYTES: 'passBytes',
    FAIL_BYTES: 'failBytes',
    RETRY_BYTES: 'retryBytes',
    SKIP_BYTES: 'skipBytes',
    TRANSFER_TIME_MILLIS: 'transferTimeMillis'
};